import funride from '../../lib/funride/funride.module.less'
import Publink from '../shared/Publink'
export default function InnerPageThesis() {
  return (
    <div>
      <header>
        <h1>
          Edgard Varese's <u>Ecuatorial</u>; A Pitch-Class Set Analysis
        </h1>
        <p>
          Here are links to the Thesis I wrote for my Masters Degree in Music
          from Eastman School of Music.
        </p>
      </header>
      <section>
        <dl>
          <dt>In smaller-sized parts</dt>
          <dd>
            <ul className={funride.singleLines}>
              <li>
                <Publink pubkey="01_thesis_cover_TOC">
                  Cover, Table of Contents, etc. (141 kb)
                </Publink>
              </li>
              <li>
                <Publink pubkey="02_thesis_chapter_1">
                  Chapter 1: Recent Theoretical Writings on the Music of Varèse
                  (1 mb)
                </Publink>
              </li>
              <li>
                <Publink pubkey="03_thesis_chapter_2">
                  Chapter 2: The Analytic Method (515 kb)
                </Publink>
              </li>
              <li>
                <Publink pubkey="04_thesis_chapter_3">
                  Chapter 3: Preliminary Analysis (464 kb)
                </Publink>
              </li>
              <li>
                <Publink pubkey="05_thesis_chapter_4">
                  Chapter 4: An Analysis of <u>Ecuatorial</u> (2.4 mb)
                </Publink>
              </li>
              <li>
                <Publink pubkey="06_thesis_Bibliography">
                  Bibliography (2.4 mb)
                </Publink>
              </li>
              <li>
                <Publink pubkey="07_thesis_Appendix_01">
                  Appendix 1: The Text of <u>Ecuatorial</u> (74 kb)
                </Publink>
              </li>
              <li>
                <Publink pubkey="08_thesis_Appendix_02">
                  Appendix 2: Score Accuracy in <u>Ecuatorial</u> (255 kb)
                </Publink>
              </li>
              <li>
                <Publink pubkey="09_thesis_Appendix_03">
                  Appendix 3: Short Score of <u>Ecuatorial</u> (1.1 mb)
                </Publink>
              </li>
            </ul>
          </dd>
          <dt>One large PDF</dt>
          <dd>
            <Publink pubkey="Sandell_MastersThesis">
              Whole Thesis (5.8 mb)
            </Publink>
          </dd>
        </dl>
      </section>
    </div>
  )
}
